/**
 * SubstitutesList - Componente presentacional para mostrar suplentes de un equipo
 * 
 * Props:
 *   - substitutes: Array de jugadores suplentes
 *   - teamLabel: Etiqueta del equipo (ej: 'Real Madrid', 'Barcelona')
 *   - classModifier: Modificador CSS para el equipo ('home' o 'away')
 */

import { getPositionAbbreviation } from "../../../../utils/positionCatalog";

export default function SubstitutesList({ substitutes = [], teamLabel = "", classModifier = "home" }) {
  if (!substitutes || substitutes.length === 0) {
    return null;
  }

  return (
    <div className={`team-substitutes team-substitutes--${classModifier}`}>
      <h4 className="substitutes-title">Suplentes - {teamLabel}</h4>
      <div className="substitutes-list">
        {substitutes.map(player => (
          <div key={player.playerId} className="substitute-item">
            <span className="shirt-number">{player.shirt}</span>
            <span className="player-name">{player.name}</span>
            <span className="position-label">{getPositionAbbreviation(player.positionLabel)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
